import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { getRecipeDetails } from "../api/RecipeApi";

export const useRecipeDetailsQueries = ({recipeId}) =>
{
  const recipeQuery = useQuery({
    queryFn: () => getRecipeDetails(recipeId),
    enabled: recipeId > 0,
  });

  return {recipeQuery};
}